
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  navigationTroughName: {
    id: "NavigationTrough.name",
    defaultMessage: "Trough",
  },
  navigationTroughTitle: {
    id: "NavigationTrough.title",
    defaultMessage: "Trough",
  },
  navigationBasinName: {
    id: "NavigationBasin.name",
    defaultMessage: "Basin dimensions",
  },
  navigationBasinTitle: {
    id: "NavigationBasin.title",
    defaultMessage: "Basin dimensions",
  },
  navigationApronName: {
    id: "NavigationApron.name",
    defaultMessage: "Apron / Backsplash",
  },
  navigationApronTitle: {
    id: "NavigationApron.title",
    defaultMessage: "Apron / Backsplash",
  },
  navigationRecessesName: {
    id: "NavigationRecesses.name",
    defaultMessage: "Recesses / built-in parts",
  },
  navigationRecessesTitle: {
    id: "NavigationRecesses.title",
    defaultMessage: "Recesses / built-in parts",
  },
  navigationColourName: {
    id: "NavigationColour.name",
    defaultMessage: "Colour",
  },
  navigationColourTitle: {
    id: "NavigationColour.title",
    defaultMessage: "Colour",
  },
  navigationAssemblyName: {
    id: "NavigationAssembly.name",
    defaultMessage: "Assembly accessories",
  },
  navigationAssemblyTitle: {
    id: "NavigationAssembly.title",
    defaultMessage: "Assembly accessories",
  },
  navigationDrainName: {
    id: "NavigationDrain.name",
    defaultMessage: "Drain",
  },
  navigationDrainTitle: {
    id: "NavigationDrain.title",
    defaultMessage: "Drain",
  },
});

export default MESSAGES;